import styled from 'styled-components';

interface RuleInputFormProps {
  hasLogicalColumn: boolean;
}

const RuleInputForm = styled.div<RuleInputFormProps>`
  padding: ${(props): string => props.theme.spaces.md};
  background-color: ${(props): string => props.theme.colors.paleBlue};
  border-bottom: solid 0.1rem
    ${(props): string => props.theme.colors.heatherGray};

  display: grid;
  grid-template-columns: ${(props): string =>
      props.hasLogicalColumn ? '10rem' : ''} 22rem 1fr 3.4rem;
  grid-column-gap: ${(props): string => props.theme.spaces.md};
`;

export { RuleInputForm };
